import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, onConsentChange, setConsent } from '../lib/analytics';
import { COMPANY } from '../mock';

const H = ({ children }) => <h2 className="font-display text-xl font-black text-[color:var(--mv-navy)] mt-8 mb-2">{children}</h2>;

export const CookiesPage = () => {
  const [c, setC] = useState(getConsent);
  useEffect(() => onConsentChange(setC), []);
  return (
    <main className="container-xl py-12 max-w-3xl text-slate-700" data-testid="cookies-page">
      <h1 className="font-display text-4xl font-black text-[color:var(--mv-navy)]">Cookies</h1>
      <p className="mt-3">This page explains the cookies and similar storage our website uses, and lets you change your choice at any time.</p>
      <div className="mt-6 rounded-xl border border-slate-200 bg-slate-50 p-5" data-testid="cookie-settings">
        <div className="font-bold text-[color:var(--mv-navy)]">Advertising cookies (Google Ads)</div>
        <p className="text-sm mt-1">Status: <strong data-testid="cookie-status">{!c ? 'not chosen yet (off)' : c.ads ? 'on' : 'off'}</strong></p>
        <div className="mt-3 flex gap-2">
          <button type="button" onClick={() => setConsent(false)} className="h-11 px-5 rounded-md border-2 border-[color:var(--mv-navy)] font-bold text-sm" data-testid="cookie-settings-reject">Turn off</button>
          <button type="button" onClick={() => setConsent(true)} className="h-11 px-5 rounded-md border-2 border-[color:var(--mv-navy)] bg-[color:var(--mv-navy)] text-white font-bold text-sm" data-testid="cookie-settings-accept">Turn on</button>
        </div>
      </div>
      <H>Always on (needed for the site to work)</H>
      <ul className="list-disc pl-5 space-y-1 text-sm">
        <li>Your cookie choice, saved in your browser so we don't ask again.</li>
        <li>Your instant quote progress and quote references, saved in your browser so you can come back to them.</li>
        <li>Sign-in for staff pages (owner and drivers only).</li>
      </ul>
      <H>Only if you accept</H>
      <ul className="list-disc pl-5 space-y-1 text-sm">
        <li><strong>Google Ads</strong> (tag {`AW-18486608053`}): tells us when someone who clicked one of our adverts goes on to request an instant quote. We send Google an anonymous code for the quote, never your name, phone, email, postcode or address.</li>
      </ul>
      <p className="mt-3 text-sm">If you turn advertising cookies off, we stop loading Google's tag and remove the Google Ads cookies we can reach on this site.</p>
      <H>Other</H>
      <p className="text-sm">Our website platform also runs its own basic usage analytics. Contact us at <a className="underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> with any questions. See also our <Link to="/privacy" className="underline">privacy policy</Link>.</p>
    </main>
  );
};

export const PrivacyPage = () => (
  <main className="container-xl py-12 max-w-3xl text-slate-700" data-testid="privacy-page">
    <h1 className="font-display text-4xl font-black text-[color:var(--mv-navy)]">Privacy policy</h1>
    <p className="mt-3">Move Van Ltd ("we") uses the details you give us only to quote for, arrange and carry out your move, delivery or clearance.</p>
    <H>What we collect</H>
    <ul className="list-disc pl-5 space-y-1 text-sm">
      <li>Name, phone number and email address.</li>
      <li>Collection and delivery postcodes or addresses, dates and job details.</li>
      <li>Photos you upload so we can estimate the job.</li>
    </ul>
    <H>How we use it</H>
    <ul className="list-disc pl-5 space-y-1 text-sm">
      <li>To give you a quote, contact you about it and manage your booking.</li>
      <li>To send you emails about your quote or booking (for example confirmations and reminders).</li>
      <li>Our crew sees the job details they need to do the work.</li>
    </ul>
    <H>Who we share it with</H>
    <p className="text-sm">Service providers that run our website, email and file storage. We do not sell your data. Google Ads receives only an anonymous quote code, and only if you accept advertising cookies — see <Link to="/cookies" className="underline">cookies</Link>.</p>
    <H>Your rights</H>
    <p className="text-sm">You can ask to see, correct or delete your details by emailing <a className="underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> or calling {COMPANY.phone}. You can also complain to the Information Commissioner's Office (ico.org.uk).</p>
  </main>
);
